import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import queryString from 'query-string';
import {push} from 'react-router-redux';
import './books-preview.css';
import { resizer1100, resizer600 } from '../../responsiver';
import {imageUrl} from '../../utilities/requests';
import {request} from '../../containers/actions';



//Radium(BooksPreview);
export default class BooksPreview extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    state = {}

    componentDidMount() {
        this.fetch(this.props.location.query.grade);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location.query.grade !== this.props.location.query.grade)
            this.fetch(nextProps.location.query.grade);
    }

    async fetch(grade) {
        const response = await this.context.store.dispatch(request({
            path: '/book/?minimal=True&published=True&react__route='+ window.location.pathname + '&' + queryString.stringify({limit: 100, category: grade}), 
        }));
        this.setState({books: response.results});
    }

    render() {

        // console.log(_.map(_.filter(this.state.books, book => book.category.id === category.id)),'gh')
        if (!this.state.books)
            return null;
        return <div style={resizer1100}>
            {_.map(_.sortBy(_.uniqBy(_.map(this.state.books, 'category'), 'id'), 'id'), category => 
            <div
                key={category.id}
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    justifyContent: 'flex-start'
                    
                }}>
                <div
                    style={{
                        backgroundColor: '#fc8207',
                        minWidth: '7em',
                        padding: '.5em',
                        textAlign: 'center',
                        verticalAlign: 'middle',
                        borderRadius: '.5em 0 0 .5em',
                        marginTop: '4rem'
                        
                    }}>
                    {window.gettext('Grade')} {category.title}
                </div>

                <div style={{display:'flex', alignItems:'center', justifyContent:'flex-start', flexFlow:'row wrap', marginBottom:'4rem'}}>
                {_.map(_.filter(this.state.books, book => book.category.id === category.id), book => <div
                    key={'book-' + book.id}
                    className='books-preview'
                    style={{
                        position: 'relative',
                        width: '10em',
                        height: '13em',
                        backgroundSize: '6.5em 9em',
                        backgroundRepeat: 'no-repeat',
                        cursor: 'pointer',
                        transform: 'perspective(200px) rotateY(15deg)',
                        transformOrigin: '10% 50% 0',
                        transition: 'all 80ms linear',
                        marginLeft: Radium.getState(this.state, 'book-' + book.id, ':hover') ? '-.9em' : '0',
                         paddingRight: Radium.getState(this.state, 'book-' + book.id, ':hover') ? '.9em' : '0',
                        // ':hover': {
                        //     transform: 'perspective(200px) rotateY(0deg)',
                        // },
                    }}
                    onClick={() => {
                        this.context.store.dispatch(push(`/book/${book.id}/0/introduction/`));
                    }}>
                    <div
                        style={{
                            position: 'relative',
                            width: '9.25em',
                            height: '12.25em',
                            border: '.125em solid #bbbbbb',
                            boxSizing: 'border-box',
                            backgroundColor: '#dddddd',
                            overflow: 'hidden',
                        }}>
                        <img
                            style={{width: '9em', height: '12em'}}
                            src={imageUrl(book.cover_photo, {width: 180, height: 240, type: 'contain'})}
                            onError={({target}) => target.style.display = 'none'}
                        />
                        {book.store_item.off
                            ? <div
                                style={{
                                    position: 'absolute',
                                    top: '0',
                                    right: '0',
                                    transform: 'translateX(50%) rotate(45deg)',
                                    transformOrigin: '50% 0',
                                    width: '8em',
                                    height: '4em',
                                    backgroundColor: 'red',
                                    textAlign: 'center',
                                    paddingTop: '1.2em',
                                    color: 'white',
                                    lineHeight: '1.3em',
                                    boxSizing: 'border-box',
                                }}>
                                <span style={{fontSize: '1.1em', fontWeight: '800'}}>
                                    {'%' + book.store_item.off.persian()}
                                    <br/>
                                    {window.gettext('Off')}
                                </span>
                            </div>
                            : null
                        }
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '0',
                            right: Radium.getState(this.state, 'book-' + book.id, ':hover') ? '10.15em' : '9.25em',
                            width: '1em',
                            height: '12.25em',
                            backgroundColor: '#cccccc',
                            borderTop: '.25em solid #ffffff',
                            borderBottom: '.25em solid #ffffff',
                            borderLeft: '.25em solid #bbbbbb',
                            borderRight: '.25em solid #bbbbbb',
                            boxSizing: 'border-box',
                            transform: Radium.getState(this.state, 'book-' + book.id, ':hover')
                                ? 'perspective(200px) rotateY(-90deg)'
                                : 'perspective(200px) rotateY(-50deg)',
                            transformOrigin: '100% 50% 0',
                            transition: 'all 80ms linear',
                        }}
                    />
                    {/* <div style={styles.tooltip(Radium.getState(this.state, 'book-' + book.id, ':hover'))}> */}
                    {/*     {book.title} */}
                    {/* </div> */}
                </div>)}
            </div>
            </div>)}
        </div>;
    }
}
